<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('invoice-over-view')" v-if="permissionCodes.indexOf('016007000') !== -1">
        <i class="el-icon-damai-shujulaiyuan"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('invoice-seller-manage')" v-if="permissionCodes.indexOf('016001000') !== -1">
        <i class="el-icon-damai-ic_xiaofangguanli"></i>
        <span slot="title">销方管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('invoice-tax-rate-manage')" v-if="permissionCodes.indexOf('016002000') !== -1">
        <i class="el-icon-damai-ic_shuishuaiguanli"></i>
        <span slot="title">税率管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('invoice-rise-manage')" v-if="permissionCodes.indexOf('016003000') !== -1">
        <i class="el-icon-damai-ic_taitouguanli"></i>
        <span slot="title">抬头管理</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('invoice-manage')" v-if="permissionCodes.indexOf('016004000') !== -1">
        <i class="el-icon-damai-ic_fapiaoguanli"></i>
        <span slot="title">发票管理</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('invoice-receipt-collection-record')" v-if="permissionCodes.indexOf('016005000') !== -1">
        <i class="el-icon-damai-ic_shoujuguanli"></i>
        <span slot="title">收据管理</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('invoice-remarks-manage')" v-if="permissionCodes.indexOf('') !== -1">
        <i class="el-icon-damai-ic_beizhuguanli"></i>
        <span slot="title">备注管理</span>
      </el-menu-item>
<!--      <el-submenu index="5" >-->
<!--        <template slot="title">-->
<!--          <i class="el-icon-damai-ic_fapiaoguanli"></i>-->
<!--          <span>发票管理</span>-->
<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="5-1" @click="toNewRouter('invoice-collection-record')">收款账单</el-menu-item>-->
<!--          <el-menu-item index="5-2" @click="toNewRouter('invoice-manage')">开票记录</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
<!--      <el-submenu index="6" >-->
<!--        <template slot="title">-->
<!--          <i class="el-icon-damai-ic_shoujuguanli"></i>-->
<!--          <span>收据管理</span>-->
<!--        </template>-->
<!--        <el-menu-item-group>-->
<!--          <el-menu-item index="6-1" @click="toNewRouter('invoice-receipt-manage')">收据账单</el-menu-item>-->
<!--          <el-menu-item index="6-2" @click="toNewRouter('invoice-receipt-collection-record')">开票记录</el-menu-item>-->
<!--        </el-menu-item-group>-->
<!--      </el-submenu>-->
      <el-menu-item index="7" @click="toNewRouter('invoice-log')" v-if="permissionCodes.indexOf('016006000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  '1': "invoice-over-view",
  '2': ['invoice-seller-manage', 'invoice-seller-add', 'invoice-seller-modify'],
  '3': ["invoice-tax-rate-manage", "invoice-tax-rate-add", "invoice-tax-rate-modify",],
  '4': ['invoice-rise-manage', 'invoice-rise-add', 'invoice-rise-modify'],
  '5': ["invoice-manage", "invoice-info-current"],
  // '5-1': ["invoice-collection-record"],
  // '5-2': ["invoice-manage", "invoice-info-current"],
  '6': ['invoice-receipt-collection-record'],
  // '6-1': ["invoice-receipt-manage"],
  // '6-2': ['invoice-receipt-collection-record'],
  '7': ["invoice-log"],
  '8': ['invoice-remarks-manage']
});

export default {
  name: "epidemic-situation-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceNav.vue